import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: '1 1 auto',
  },
  content: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.paper,
    '& $scrollableContainer': {
      boxSizing: 'border-box',
      padding: theme.spacing(2, 4, 0, 4),
    },
  },
  menu: {
    color: theme.palette.common.white,
    width: '256px',
    borderRight: `1px solid ${theme.palette.custom.border}`,
  },
  navMenu: {
    boxSizing: 'border-box',
    padding: theme.spacing(4, 2),
  },
  scrollWrapper: {
    overflow: 'overlay',
    position: 'relative',
  },
  scrollableContainer: {
    minHeight: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  breadcrumb: {
    '& span': {
      fontSize: '14px',
    },
  },
}));
